import { Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { AdjudicationAdjudicatorDecision } from "neurotec-megamatcherid-management-client"
import DataTableCell from "../../../components/Misc/DataTable/DataTableCell"

interface IAdjudicationDecisionOverview {
    decisions: AdjudicationAdjudicatorDecision[]
}

const AdjudicationDecisionOverview: React.FC<IAdjudicationDecisionOverview> = (props) => {
    return (
        <Grid container>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Date
                        </TableCell>
                        <TableCell>
                            Username
                        </TableCell>
                        <TableCell>
                            Type of attack
                        </TableCell>
                        <TableCell>
                            Decision
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.decisions.map(d => 
                    <TableRow key={d.uuid}>
                        <DataTableCell value={d.date} type="date" align="left"/>
                        <DataTableCell value={d.username} type="string" align="left" tooltipValue={d.username}/>
                        <DataTableCell value={d.typeOfAttack} type="attack" align="left"/>
                        <DataTableCell value={d.decision} type="decision" align="left"/>
                    </TableRow>
                )}
                </TableBody>
            </Table>
        </Grid>
    )
}

export default AdjudicationDecisionOverview